import { capitalizeEachWord } from '@y42/util/capitalize-each-word';
import { AclRole } from '../models';

const roleLabels: Partial<Record<AclRole, string>> = {};

export const getRoleLabel = (role: AclRole): string => {
  let label = roleLabels[role];

  if (!label) {
    label = capitalizeEachWord(role.replace(/_/g, ' '));
    roleLabels[role] = label;
  }

  return label;
};
